var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediumUpAngleBracket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 7,
    viewBox: "0 0 15 9",
    fill: "none",
    className: " ",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9901 8.60275C14.3887 8.16684 14.3887 7.46001 13.9901 7.0241L7.86651 0.326363C7.46797 -0.109548 6.82172 -0.109548 6.42318 0.326363L0.29956 7.0241C-0.0989857 7.46001 -0.0989857 8.16684 0.29956 8.60275C0.698105 9.03867 1.34435 9.03867 1.7429 8.60275L7.14484 2.69435L12.5468 8.60275C12.9454 9.03867 13.5916 9.03867 13.9901 8.60275Z",
    fill: "#545F65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumUpAngleBracket);
export default __webpack_public_path__ + "static/media/mediumUpAngleBracket.b2fdeeaf5c3bc6fd460fee7e6f3684e6.svg";
export { ForwardRef as ReactComponent };